class TokenService {
   getLocalRefreshToken() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user?.refreshToken;
   }

   getLocalAccessToken() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user?.access_token;
   }

   getRememberMe() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user?.access_token;
   }

   updateLocalAccessToken(token) {
      let user = JSON.parse(localStorage.getItem('user'));
      user.access_token = token;
      localStorage.setItem('user', JSON.stringify(user));
   }

   getUser() {
      const userToken = JSON.parse(localStorage.getItem('user'));
      const token = userToken?.access_token;
      if (!token) {
         return false;
      }
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
         atob(base64)
            .split('')
            .map(function (c) {
               return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(''),
      );

      const { user } = JSON.parse(jsonPayload);
      return JSON.parse(localStorage.getItem('user'));
   }

   setUser(user) {
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('isAuthenticated', true);
   }

   setRememberMe(rememberMe) {
      localStorage.setItem('rememberMe', rememberMe);
   }

   removeUser() {
      localStorage.removeItem('user');
   }

   checkAuthenticated() {
      const storedUser = localStorage.getItem('user');
      if (!storedUser) return false;
      let user;
      try {
         user = JSON.parse(storedUser);
      } catch (e) {
         console.error("Invalid user data in localStorage");
         return false;
      }
      const token = user?.access_token;
      if (!token) return false;
      try {
         // Decode JWT
         const base64Url = token.split('.')[1];
         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
         const jsonPayload = decodeURIComponent(
            atob(base64)
               .split('')
               .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
               .join('')
         );

         let { sub, exp, name, access } = JSON.parse(jsonPayload);
         localStorage.setItem("name", name);
         localStorage.setItem("access", access);

         // If "exp" is ISO string from backend
         if (typeof exp === "string" && exp.includes("T")) {
            exp = new Date(exp).getTime() / 1000; // convert to seconds
         }
         const expired = Date.now() > exp * 1000;
         return !expired;
      } catch (error) {
         console.error("Error decoding token:", error);
         return false;
      }
   }

}

export default new TokenService();
